import { theme } from 'global'
import {
  space,
  SpaceProps,
  color,
  ColorProps,
  layout,
  LayoutProps,
  display,
  DisplayProps,
  compose,
} from 'styled-system'

export type CommonProps = SpaceProps & LayoutProps & ColorProps & DisplayProps

export const COMMON = compose(space, color, layout, display)

export type UIColorThemes = 'light' | 'dark'

export interface UIColorTheme {
  uiColorTheme?: UIColorThemes
}

export type ThemeAnimalColor =
  | 'animalBlue'
  | 'animalPurple'
  | 'animalRed'
  | 'animalOrange'
  | 'animalPink'
  | 'animalGreen'
  | 'animalLightBlue'

export type HandAnimalType =
  | 'bull'
  | 'kitten'
  | 'stallion'
  | 'falcon'
  | 'cougar'
  | 'bunny'
  | 'bear'
  | 'hummingbird'
  | 'crab'
  | 'frog'
  | 'peacock'
  | 'turtle'
  | 'fox'
  | 'spider'
  | 'scorpion'
  | 'dove'
  | 'swan'
  | 'butterfly'
  | 'dolphin'
  | 'shark'
  | 'bat'
  | 'snake'
  | 'dragon'
  | 'cub'
  | 'otter'

export type HandAnimalColor =
  | 'blue'
  | 'purple'
  | 'red'
  | 'orange'
  | 'pink'
  | 'green'
  | 'lightBlue'

export const THEME_ANIMAL_COLORS: {
  [key in HandAnimalColor]: ThemeAnimalColor
} = {
  blue: 'animalBlue',
  purple: 'animalPurple',
  red: 'animalRed',
  orange: 'animalOrange',
  pink: 'animalPink',
  green: 'animalGreen',
  lightBlue: 'animalLightBlue',
}

export const ANIMAL_COLOR_TO_UI_THEME: {
  [key in HandAnimalColor]: UIColorThemes
} = {
  blue: 'light',
  purple: 'light',
  red: 'dark',
  orange: 'dark',
  pink: 'dark',
  green: 'dark',
  lightBlue: 'dark',
}

export const ANIMALS: HandAnimalType[] = [
  'bull',
  'kitten',
  'stallion',
  'falcon',
  'cougar',
  'bunny',
  'dolphin',
  'frog',
  'cub',
  'bear',
  'hummingbird',
  'turtle',
  'fox',
  'spider',
  'swan',
  'peacock',
  'scorpion',
  'dove',
  'butterfly',
  'shark',
  'bat',
  'snake',
  'dragon',
  'crab',
  'otter',
]

export const ANIMAL_COLORS: HandAnimalColor[] = [
  'blue',
  'purple',
  'red',
  'orange',
  'pink',
  'green',
  'lightBlue',
]

// Breakpoint of Webflow application increased header size.
export const WEBFLOW_LARGE_HEADER_BREAKPOINT = 992
// Topbar (a.k.a webflow header)
export const MOBILE_TOPBAR_HEIGHT = 60
export const TOPBAR_HEIGHT = 90

// Component fixed dimensions
export const CARD_WIDTH = 270
export const CARD_HEIGHT = 378

export const SCREEN_DEFAULT_COLOR = {
  StartScreen: theme.colors.blue,
  QuestionsScreen: theme.colors.kinkyPurple,
  HandScreen: theme.colors.kinkyPurple,
  DigestScreen: theme.colors.kinkyPurple,
}

// This is the base rotation degrees for the hand to digest filigree animation.
export const FILIGREE_ROTATE_ANIM_BASE_DEGREES = -120
